exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sub{\r\n    width: 90%;\r\n    float: right;\n}\r\n", ""]);

// exports
